import React, { ChangeEventHandler, MouseEventHandler } from 'react';

import { RadioOrSelectOption } from '../../../../../types/common.types';
import { Member, SearchResult } from '../../../../../types/entity.types';

import TribeFeedWrapper from '../feed/wrapper/TribeFeedWrapper';
import TribeInfo from '../info/TribeInfo';
import TribeSearchResult from '../search-result/TribeSearchResult';

import { ReactComponent as ArrowIcon } from '../../../../../resources/icons/arrow-single.svg';

import './tribe-search-results.scss';

type Props = {
  results: SearchResult[];
  profilePicture?: string;
  onBackClick: MouseEventHandler<HTMLDivElement>;
  onComposeClick: MouseEventHandler<HTMLButtonElement>;
  members: Member[];
  status: string;
  pendingApprovals: number;
  filterValue: string;
  onFilterValueChange: ChangeEventHandler<HTMLInputElement>;
  searchType?: RadioOrSelectOption;
  onSearchTypeChange: (option: RadioOrSelectOption) => void;
  onSearchClick: MouseEventHandler<HTMLButtonElement>;
  onLoadPostWithHierarchy: (externalReference: string) => void;
};

const TribeSearchResults = ({
  results,
  profilePicture,
  onBackClick,
  onComposeClick,
  members,
  status,
  pendingApprovals,
  filterValue,
  onFilterValueChange,
  searchType,
  onSearchTypeChange,
  onSearchClick,
  onLoadPostWithHierarchy
}: Props) => (
  <div className="tribe-search-results">
    <div className="tribe__header">
      <ArrowIcon className="tribe__header__arrow-icon" onClick={onBackClick} data-testid="arrow-icon" />
      <h1>Search Results</h1>
    </div>
    <div className="tribe-search-results__content">
      <TribeFeedWrapper
        status={status}
        profilePicture={profilePicture}
        filterValue={filterValue}
        onFilterValueChange={onFilterValueChange}
        searchType={searchType}
        onSearchTypeChange={onSearchTypeChange}
        onComposeClick={onComposeClick}
        onSearchClick={onSearchClick}
      >
        <div className="tribe-search-results__results">
          {results.map((result, index) => (
            <TribeSearchResult
              key={`result_${index}`}
              result={result}
              searchValue={filterValue}
              onLoadPostWithHierarchy={onLoadPostWithHierarchy}
            />
          ))}
          {results.length === 0 && (
            <div className="tribe-search-results__results--empty">
              <p>No results found</p>
            </div>
          )}
        </div>
      </TribeFeedWrapper>
      <TribeInfo members={members} status={status} pendingApprovals={pendingApprovals} />
    </div>
  </div>
);

export default TribeSearchResults;
